import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { isUndefined } from 'util';

@Component({
  selector: 'app-scenariolist',
  templateUrl: './scenariolist.component.html',
  styleUrls: ['./scenariolist.component.css']
})
export class ScenariolistComponent  extends BaseComponent implements OnInit {
  organizations: any = []
  scenarios: any = [] //loaded from db
  scenariosdisplay: any = [] //shown in table
  scenario: any = {};
  userRoles: any = []
  organizationId:any = ""
  isAdmin = false;
  scenariogroups: any = []
  showScenWizard = false;
  newScenario:any = {}
  sortArray:any = []
  key = 0
  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.loader.show()
    this.organizations = await this.db.get("Organization", "getOrganizations")
    this.organizationId= sessionStorage.getItem('organizationId');

    await this.getData()

    this.scenariogroups = this.groupBy(this.scenarios,"organizationId")
    this.scenariogroups.forEach((sg:any)=>{
      sg.orgname = ""
      let org = this.organizations.find((x:any) => x.id == sg.key)
      if (org != null) sg.orgname = org.name
    })
    this.sort(this.scenariogroups,"orgname")

    this.scenariosdisplay  = this.scenarios
    this.loader.hide()
  }

  async getData() {
    this.scenarios = await this.db.get("scenario", "getscenarios")
    this.scenarios.forEach((s:any)=>{
      s.orgname = this.findObjectProp(this.organizations,"name",s.organizationId)
    })

  }

  selectScenario(scenario: any) {
    this.router.navigate(['scenarioedit2'],{ queryParams: { id: scenario.id } })
  }
  
  async submit() {
    this.loader.show();
    const resp = await this.db.post("scenario", "postscenario", this.scenario);
    await this.getData();
    this.loader.hide();
  }

  add() {
    this.newScenario = {"name":"",organizationId:this.organizationId,selectedType:"GPS"}
    this.showScenWizard = true
    //this.router.navigate(['scenario'],{ queryParams: { id: 0 } })
  }

  async createNewScenario(){
    //verify name is unique
    let dupScenario = this.scenarios.find((s:any) => s.organizationId == this.organizationId && s.name == this.newScenario.name)
    if (dupScenario != null){
      this.alert.danger("The name is not unique. Choose a different name")
      return
    }
    let hasGPS = this.newScenario.selectedType == "GPS" ? true : false
    let query = {name: this.newScenario.name, organizationid: this.organizationId,hasGPS}
    let scen = await this.db.post("Scenario","createScenario",{},query)
    this.router.navigate(['scenarioedit2'],{ queryParams: { id: scen.id } })
  }
  
  async delete(scenario: any) {
    this.confirm.show("Do you want to delete Scenario "+scenario.name+"?",
      () => this.deleteScenario(scenario),
      () => this.toast.info("No scenario deleted!")
    )
  }

  async deleteScenario(scenario:any){
    this.loader.show();
    const resp = await this.db.delete("scenario", "deletescenario", { id: scenario.id });
    this.scenario = {}
    await this.getData()
    this.filterByOrg(0)
    this.loader.hide()
  }

  filterByOrg(id: any){
    if (id == 0){
      this.scenariosdisplay = this.scenarios
      return
    }
    this.scenariosdisplay = [];
    this.scenarios.forEach((scen:any) =>{
      if (scen.organizationId == id){
        this.scenariosdisplay.push(scen)
      }
    });
  }
}
